import Api from '@/services/api.js';

export default {
  addProject(details) {
    return Api.post('projects/', details);
  },
  getProjects(clientId) {
    if (!!clientId) {
      return this.getProjectsByClient(clientId)
    } else {
      return this.getAllProjects()
    }
  },
  getAllProjects() {
    return Api.get('projects/');
  },
  getProjectsByClient(client) {
    return Api.get('projects/byClient/' + client);
  },
  deleteProject(project) {
    return Api.delete(`projects/${project}`);
  },
  updateProject(project) {
    var projectId = project.id;
    return Api.put(`projects/${projectId}`, project);
  }

}